module.exports = __webpack_public_path__ + "img/instagramestory2-1.83257cb5.jpg";